import types from '../types/orchestrator'
import startTypes from '../types/start'
import reservationTypes from '../types/reservation'
import {Map} from 'immutable'

export const steps = {
  NONE: 'none',
  START: 'start',
  RESERVATION: 'reservation',
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  ADDRESS: 'address',
  PAYMENT: 'payment',
  REVIEW: 'review',
}

const initialRoot = Map({
  rent: null,
  itemId: '',
  step: steps.NONE,
  previousStep: steps.NONE,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_STEP:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_NONE:
      return state
        .merge(setStep(state, action.payload.step))
        .set('itemId', action.payload.itemId)
    case types.NEXT_STEP_FROM_START:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_RESERVATION:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_DELIVERY:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_PICKUP:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_ADDRESS:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_PAYMENT:
      return state.merge(setStep(state, action.payload.step))
    case types.NEXT_STEP_FROM_REVIEW:
      return state
        .merge(setStep(state, action.payload.step))
        .set('previousStep', steps.NONE)
        .set('itemId', '')
    case startTypes.CREATE_RENT_SUCCESS:
      return state.merge(setRent(action.payload.rent))
    case startTypes.CREATE_RENT_FAIL:
      return state.merge(setRent(null))
    case reservationTypes.SAVE_ADD_ITEM_SUCCESS:
      return state
        .setIn(['rent', 'StartDate'], action.payload.startDate)
        .setIn(['rent', 'EndDate'], action.payload.endDate)
    default:
      return state
  }
}

function setStep(state, step) {
  return {
    step: step,
    previousStep: state.get('step'),
  }
}

function setRent(rent) {
  return {
    rent: rent === null ? null : Map(rent),
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/rent/reducers/orchestrator.js